/* Gate2Buy design helpers: product rails, collection description toggle, sticky add-to-cart */
(function () {
  function initRails(root) {
    (root || document).querySelectorAll('[data-g2b-rail]').forEach(function (rail) {
      if (rail.dataset.ready) return;
      rail.dataset.ready = '1';
      var track = rail.querySelector('.g2b-rail__track');
      var prev = rail.querySelector('[data-g2b-prev]');
      var next = rail.querySelector('[data-g2b-next]');
      if (!track) return;
      function step() { return Math.max(track.clientWidth * 0.9, 200); }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        var nav = rail.querySelector('.g2b-nav');
        if (nav) nav.style.visibility = max <= 2 ? 'hidden' : '';
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  window.g2bInitRails = initRails;

  function initDesc() {
    document.querySelectorAll('[data-g2b-desc]').forEach(function (box) {
      var inner = box.querySelector('.g2b-ch__desc-inner');
      var btn = box.querySelector('.g2b-ch__more');
      if (!inner || !btn) return;
      if (inner.scrollHeight <= inner.clientHeight + 4) { btn.hidden = true; return; }
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-clamped') === false;
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-g2b-sticky]');
    if (!bar) return;
    var mainBtn = document.querySelector('[id^="MainProduct-"] .product-form__submit') || document.querySelector('[id^="MainProduct-"] form[action*="/cart/add"] [type=submit]');
    if (!mainBtn) { bar.remove(); return; }
    var stickyBtn = bar.querySelector('[data-g2b-sticky-btn]');
    stickyBtn.addEventListener('click', function () {
      if (mainBtn.disabled) { mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      mainBtn.click();
    });
    function sync() {
      stickyBtn.disabled = mainBtn.disabled;
      var label = mainBtn.querySelector('span');
      if (label && label.textContent.trim()) stickyBtn.textContent = label.textContent.trim();
      var sale = document.querySelector('[id^="price-"] .price--on-sale .price__sale .price-item--sale');
      var regular = document.querySelector('[id^="price-"] .price__regular .price-item--regular');
      var src = sale || regular;
      var target = bar.querySelector('.g2b-sticky__price');
      if (src && target && src.textContent.trim()) target.textContent = src.textContent.trim();
    }
    var scope = document.querySelector('[id^="MainProduct-"]');
    if (scope) new MutationObserver(function () { window.requestAnimationFrame(sync); }).observe(scope, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
    sync();
    var ticking = false;
    function check() {
      ticking = false;
      var past = mainBtn.getBoundingClientRect().bottom < 0;
      if (bar.classList.contains('is-visible') !== past) {
        bar.classList.toggle('is-visible', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  function init() { initRails(); initDesc(); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initRails(e.target); });
})();
